// extracted by mini-css-extract-plugin
module.exports = {"root":"Link_root__yR_FW","clipboard":"Link_clipboard__1EIRF","arrow":"Link_arrow__Ju5tl","success":"Link_success__2gs1p"};